import { AnyAction } from 'redux';
import {
  BUY_BUTTON_SET_ARTICLE_NUMBER,
  BUY_BUTTON_SET_UPSELL_ARTICLE_NUMBERS,
} from '../constants';

export interface BuyButtonState {
  articleNumber?: string;
  disabled?: boolean;
  isLoading?: boolean;
  upSellIds?: string[];
}

const DEFAULT_STATE: BuyButtonState = {};

export const buyButton = (
  state = DEFAULT_STATE,
  action: AnyAction
): BuyButtonState => {
  switch (action.type) {
    case BUY_BUTTON_SET_ARTICLE_NUMBER:
    case BUY_BUTTON_SET_UPSELL_ARTICLE_NUMBERS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
